import { useAtom } from "jotai";
import { useState } from "react";
import { planogramSelectedItemsAtom } from "src/components/PlanogramExtensions/store/atoms";
import { Flex, Grid } from "src/elements/Box/Box";
import { Color } from "src/elements/Color/Color";
import { ProductsDetails } from "../Panel/panels/ProductsDetails/ProductsDetails";
import { ProductDetails } from "../Panel/panels/ProductDetails/ProductDetails";
import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { SidepanelButton } from "../Panel/panels/NewShelf/components/SidepanelButton";
import { SidepanelLockButton } from "../Panel/components/LockButton";
import { SidepanelToggleButton } from "../Panel/components/ToggleButton";
import { PlanogramSidepanelTab } from "src/components/PlanogramExtensions/store/types";

interface Props {
  pog: Pog;
  setPog: React.Dispatch<React.SetStateAction<Pog>>;
}

export const Planogram3dPanel = ({ pog, setPog }: Props) => {
  const [isLocked, setIsLocked] = useState(false);
  const [tab, setTab] = useState<PlanogramSidepanelTab>("PRODUCT_DETAILS");
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedItems] = useAtom(planogramSelectedItemsAtom);

  return (
    <Grid
      columns="1fr auto"
      border={`1px solid ${Color.greenSmokeActive}`}
      borderRadius="3px"
      overflow="hidden"
    >
      {isExpanded && (
        <Flex width="320px" flexGrow borderRight={`1px solid ${Color.greenSmokeActive}`}>
          {tab === "PRODUCT_DETAILS" &&
            (selectedItems.length > 1 ? (
              <ProductsDetails pog={pog} setPog={setPog} />
            ) : (
              <ProductDetails pog={pog} setPog={setPog} />
            ))}
        </Flex>
      )}

      <Flex
        width="28px"
        minWidth="28px"
        column
        align="between"
        background={Color.greenSmokeDisabled}
      >
        <Flex column>
          <SidepanelButton
            tab="PRODUCT_DETAILS"
            setTab={setTab}
            currentTab={tab}
            isDisabled={selectedItems.length === 0}
          >
            Product
          </SidepanelButton>
        </Flex>

        <Flex column>
          <SidepanelLockButton isLocked={isLocked} setIsLocked={setIsLocked} />
          <SidepanelToggleButton isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </Flex>
      </Flex>
    </Grid>
  );
};
